import { render, staticRenderFns } from "./dialogEditSH.vue?vue&type=template&id=4064cef9&scoped=true"
import script from "./dialogEditSH.vue?vue&type=script&lang=js"
export * from "./dialogEditSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4064cef9",
  null
  
)

export default component.exports